import { ArrowLeft2 } from 'iconsax-react';
import { TInvestmentBannerProps } from '../model';
import Link from 'next/link';

export function InvestmentConsultingBanner(props: TInvestmentBannerProps) {
  return (
    <Link
      href={props.href}
      className='flex flex-col justify-self-center w-full md:w-[1000px] md:min-w-[900px] overflow-hidden rounded-[16px] bg-background border border-border'
    >
      <div className='relative flex w-full flex-row justify-between py-3 md:py-2 px-3'>
        <div className='flex flex-row items-center gap-3'>
          <div
            className='size-[56px] md:size-[40px] bg-cover bg-center flex-shrink-0'
            style={{ backgroundImage: `url(${props.image})` }}
          />
          <div className='flex flex-col gap-1'>
            <div className='flex-col items-start justify-between'>
              <div className='flex flex-col gap-2'>
                <p className='text-text font-bold'>{props.title}</p>
              </div>
            </div>
            <p className='text-[12px] text-icons'>{props.description}</p>
          </div>
        </div>
        <span className='bg-[#F3F5F9] rounded-[8px] p-[6px] h-[32px] w-[32px] justify-self-center self-center'>
          <ArrowLeft2 size={20} className='text-[#323e54]' />
        </span>
      </div>
    </Link>
  );
}
